import { requestJson } from './http'

export interface DistributorEvent {
  type: string
  occurredAt: string
  data: Record<string, unknown>
}

export const fetchDistributorEvents = async (): Promise<DistributorEvent[]> => {
  const response = await requestJson<{ events: DistributorEvent[] }>('/borgo/distributor/events', 'GET')
  return response.events
}
